<div id="content" class="allcp-form" ng-controller="CustomerAccountController" ng-init="init()">
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system">
        <ul class="nav navbar-nav nav-tabs navbar-left">
            <li class="active">
                <a target="_self" class="btn btn-operation ml10" href="#company-info" data-toggle="tab">Company Info</a>
            </li>
            <li>
                <a target="_self" class="btn btn-operation ml10" href="#change-password" data-toggle="tab">Change Password</a>
            </li>
            <li>
                <a class="btn btn-operation ml10" href="customer-integrations">Integrations</a>
            </li>
            <li>
                <a target="_self" class="btn btn-operation ml10" href="#creditcards" data-toggle="tab">My Cards</a>
            </li>
        </ul>
    </header>
    <div class="panel-body">
        <div class="row">
            <div class="col-md-12">
                <div class="tab-content">
                    <div class="tab-pane active" id="company-info">
                        <div class="col-md-12">
                            <form class="row form-horizontal" ng-submit="updateCustomerInfo()">
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col pr-2">
                                            <div class="form-group floating">
                                                <input type="text" class="form-control " placeholder="Company Name" ng-model="customer.customer.customer_name" required>
                                                <label>
                                                    Company Name
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col pl-2">
                                            <div class="form-group floating">
                                                <input type="text" class="form-control " placeholder="Doing Business As (DBA)" ng-model="customer.customer.dba_name" style="border-color: #ff9234;">
                                                <label>
                                                    Doing Business As (DBA)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group floating">
                                        <input type="text" ng-model="customer.customer.address" placeholder="Street Address" class="form-control ">
                                        <label>
                                            Street Address
                                        </label>
                                    </div>
                                    <div class="form-group floating">
                                        <input type="text" ng-model="customer.customer.address_two" placeholder="Apartment, Suite, Building (Optional)" class="form-control ">
                                        <label>
                                            Apartment, Suite, Building (Optional)
                                        </label>
                                    </div>
                                    <div class="row">
                                        <div class="col pr-2">
                                            <div class="form-group floating">
                                                <input type="text" placeholder="City" ng-model="customer.customer.city" required class="form-control ">
                                                <label>
                                                    City
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col pl-2 pr-2">
                                            <div class="form-group floating">
                                                <select ng-model="customer.customer.state" class="form-control ">
                                                    <option value="">Select State</option>
                                                    <option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
                                                </select>
                                                <label>
                                                    State
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col pl-2">
                                            <div class="form-group floating">
                                                <input type="text" ng-model="customer.customer.zipcode" placeholder="Zipcode" class="form-control ">
                                                <label>
                                                    Zipcode
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group floating">
                                        <input type="text" placeholder="Authorized Name" class="form-control " ng-model="customer.customer.authorized">
                                        <label>Authorized Name</label>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group floating">
                                                <input type="text" name="store-phone" ui-mask="(999) 999-9999" ui-mask-placeholder=" " ui-mask-placeholder-char=" " placeholder="Phone Number" class="form-control " ng-model="customer.customer.phone_number" required>
                                                <label>Phone Number</label>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group floating">
                                                <input type="text" name="store-phone" ui-mask="(999) 999-9999" ui-mask-placeholder=" " ui-mask-placeholder-char=" " placeholder="Customer Service Phone Number" class="form-control " ng-model="customer.customer.cs_phone_number" required style="border-color: #ff9234;">
                                                <label>Customer Service Phone Number</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group floating">
                                        <input type="text" name="store-email" id="store-email" class="form-control " placeholder="Email" disabled="true" ng-model="customer.user.email" required>
                                        <label>Email</label>
                                    </div>
                                    <button type="submit" class="btn">Update</button>
                                    <p>
                                        <small style="font-size:12px;color: #ff9234;">* We will use your Doing Business As and Customer Service Phone Number when we send SMS to your customers after each delivery.</small>
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <div class="fileupload fileupload-new" data-provides="fileupload">
                                        <div class="fileupload-preview thumbnail">
                                            <img ng-if="customer.customer.logo" 
                                                class="img-responsive center" 
                                                style="height:220px"
                                                ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ customer.customer.logo }}" />
                                            <i ng-if="!customer.customer.logo" class="icon-drag-icon"></i>
                                            <p>Drag logo here</p>
                                            <div class="line-seperator">
                                                <div class="line"></div>
                                                <p>OR</p>
                                                <div class="line"></div>
                                            </div>
                                            <div class="logo_upload" ng-repeat="item in logo.queue" style="width:50%">
                                                <div class="progress" ng-if="proccessProfile">
                                                    <div 
                                                        class="progress-bar progress-bar-success progress-bar-striped active" 
                                                        role="progressbar" 
                                                        aria-valuenow="60" 
                                                        aria-valuemin="0" 
                                                        aria-valuemax="100" 
                                                        ng-style="{ 'width': item.progress + '%' }"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="btn btn-outline btn-file">
                                                <span class="fileupload-new">Upload a logo from your computer</span>
                                                <input type="file" nv-file-select uploader="logo">
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="tab-pane" id="change-password">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <form class="form-horizontal" name="change_password_form" ng-submit="updatePassword()">
                                        <div class="form-group floating show-hide-pass">
                                            <input type="{{inputTypeArr[0]}}" name="old_password" id="old_password" ng-minlength="6" placeholder="******" class="form-control " ng-model="password.old_password" required>
                                            <label>Old Password</label>
                                            <a href="" ng-click="hideShowPasswordArr(0)">
                                                <i ng-if="inputTypeArr[0] == 'password'" class="fa fa-eye-slash"></i>
                                                <i ng-if="inputTypeArr[0] == 'text'" class="fa fa-eye"></i>
                                            </a>
                                            <span ng-show="change_password_form.old_password.$dirty&&change_password_form.old_password.$error.required">Required *</span>
                                            <span ng-show="change_password_form.old_password.$dirty&&change_password_form.old_password.$error.minlength">Value should be more than 6</span>
                                        </div>
                                        <div class="form-group floating show-hide-pass">
                                            <input type="{{inputTypeArr[1]}}" name="new_password" id="new_password" ng-minlength="6" placeholder="******" class="form-control " ng-model="password.new_password" required>
                                            <label>
                                                New Password
                                            </label>
                                            <a href="" ng-click="hideShowPasswordArr(1)">
                                                <i ng-if="inputTypeArr[1] == 'password'" class="fa fa-eye-slash"></i>
                                                <i ng-if="inputTypeArr[1] == 'text'" class="fa fa-eye"></i>
                                            </a>
                                            <span ng-show="change_password_form.new_password.$dirty&&change_password_form.new_password.$error.required">Required *</span>
                                            <span ng-show="change_password_form.new_password.$dirty&&change_password_form.new_password.$error.minlength">Value should be more than 6</span>
                                        </div>
                                        <div class="form-group floating show-hide-pass">
                                            <input type="{{inputTypeArr[2]}}" name="cofirm_new_password" id="cofirm_new_password" placeholder="******" class="form-control " ng-model="password.new_password_repeat" required compare-to="password.new_password">
                                            <label>
                                                Repeat New Password
                                            </label>
                                            <a href="" ng-click="hideShowPasswordArr(2)">
                                                <i ng-if="inputTypeArr[2] == 'password'" class="fa fa-eye-slash"></i>
                                                <i ng-if="inputTypeArr[2] == 'text'" class="fa fa-eye"></i>
                                            </a>
                                            <span ng-show="change_password_form.cofirm_new_password.$dirty&&change_password_form.cofirm_new_password.$error.required">Required *</span>
                                            <span ng-show="change_password_form.cofirm_new_password.$error.compareTo">Value should be same !</span>
                                        </div>
                                        <button type="submit" class="btn ">Update</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="creditcards">
                        <div ng-include="'modules/customer/cards.html'"></div>
                    </div>
                    <div class="tab-pane" id="my-cards">
                        <div class="col-md-12">
                            <form class="form-horizontal" name="change_bankinfo_form" ng-submit="updateBankInfo()">
                                <div class="form-group">
                                    <label for="bank_name" class="col-md-3 control-label">Bank Name :</label>
                                    <div class="col-md-9">
                                        <label for="bank_name" class="field">
                                            <input type="text" name="bank_name" id="bank_name" ng-minlength="6" placeholder="Bank Name" class="form-control" ng-model="bank_info.bank_name" required>
                                            <label for="bank_name" class="field-icon">
                                                <i class="fa fa-lock"></i>
                                            </label>
                                        </label>
                                    </div>
                                </div>
                                <!-- <div class="form-group">
                                    <label for="branch_name" class="col-md-3 control-label">Branch Name :</label>
                                    <div class="col-md-9">
                                        <label for="branch_name" class="field">
                                            <input type="text" name="branch_name" id="branch_name" ng-minlength="6" placeholder="Branch Name" class="form-control" ng-model="bank_info.branch_name" required>
                                            <label for="branch_name" class="field-icon">
                                                <i class="fa fa-lock"></i>
                                            </label>
                                        </label>
                                    </div>
                                </div> -->
                                <div class="form-group">
                                    <label for="bank_account_number" class="col-md-3 control-label">Bank Account Number :</label>
                                    <div class="col-md-9">
                                        <label for="bank_account_number" class="field">
                                            <input type="text" name="bank_account_number" id="bank_account_number" ng-minlength="6" placeholder="Bank Account Number" class="form-control" ng-model="bank_info.bank_account_number" required>
                                            <label for="bank_account_number" class="field-icon">
                                                <i class="fa fa-lock"></i>
                                            </label>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="sort_code" class="col-md-3 control-label">Bank Sort Code :</label>
                                    <div class="col-md-9">
                                        <label for="sort_code" class="field">
                                            <input type="text" name="sort_code" id="sort_code" placeholder="sort_code" class="form-control" ng-model="bank_info.sort_code" required>
                                            <label for="sort_code" class="field-icon">
                                                <i class="fa fa-lock"></i>
                                            </label>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-md-12">
                                        <div class="pull-right">
                                            <button type="submit" class="btn btn-primary">Update Bank Info</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
